// src/components/Footer.js
import React from 'react';
import { Box, Typography, Link } from '@mui/material';

export default function Footer() {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: '#1976d2',
                color: 'white',
                py: 2, // padding top and bottom
                textAlign: 'center',
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%'
            }}
        >
            <Typography variant="body2">
                &copy; 2024 NorthTown. All rights reserved. |
                <Link href="#" color="inherit" underline="hover" sx={{ marginLeft: 1 }}>
                    关于我们
                </Link> |
                <Link href="#" color="inherit" underline="hover" sx={{ marginLeft: 1 }}>
                    联系我们
                </Link> |
                <Link href="#" color="inherit" underline="hover" sx={{ marginLeft: 1 }}>
                    服务条款
                </Link> |
                <Link href="#" color="inherit" underline="hover" sx={{ marginLeft: 1 }}>
                    帮助中心
                </Link>
            </Typography>
        </Box>
    );
}
